import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UserNavigationService, UserService } from '../services';

export const userNavigationGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const navService = inject(UserNavigationService);

  const url = (state?.url || '/').split('?')[0];

  return toObservable(userService.user).pipe(
    filter((user) => !!user),
    take(1),
    map(() => {
      const hasPath = navService.hasPath(url);
      if (hasPath) return true;

      const firstPath = navService.getFirstPath();
      if (firstPath) return router.createUrlTree([`/${firstPath}`]);

      return false;
    }),
  );
};
